import { Alert } from 'antd';
import { AlertProps } from 'antd/lib/alert';

interface Props extends AlertProps {}

export default function EnhancedAlert(props: Props) {
    return <Alert {...props} />;
}
